import { ReactNode } from "react";
import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface IIotVisionDialogProps {
    open: boolean;
    title: ReactNode;
    onClose: () => void;
    children: ReactNode;
    maxWidth?: DialogProps["maxWidth"];
    fullWidth?: boolean;
}

const IotVisionDialog = ({
    open,
    title,
    onClose,
    children,
    maxWidth = "sm",
    fullWidth = true,
}: IIotVisionDialogProps): JSX.Element => (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {title}
            <IconButton aria-label="close" onClick={onClose} size="small">
                <CloseIcon fontSize="small" />
            </IconButton>
        </DialogTitle>
        <DialogContent dividers>{children}</DialogContent>
    </Dialog>
);

export default IotVisionDialog;
